import Layout1 from './layouts/layout1/index';

export const layoutRegistry = {
	layout1: Layout1,
	// TODO layout2: Layout2 (phase3)
};
